<script setup>
const rosters = {
  'NBA': ['Team A', 'Team B', 'Team C'],
  'WNBA': ['Team X', 'Team Y', 'Team Z'],
}
</script>

<template>
  <div class="p-4">
    <div v-for="(teams, league) in rosters" :key="league" class="mb-4">
      <h3 class="font-semibold text-gray-500 mb-2">{{ league }}</h3>
      <div class="bg-white rounded-lg shadow">
        <ul class="divide-y divide-gray-200">
          <li v-for="team in teams" :key="team">
            <a href="#" class="flex items-center p-4 hover:bg-gray-50">
              <span>{{ team }}</span>
              <i class="fas fa-chevron-right ml-auto text-gray-400"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template> 